import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import {
  LinkStyled,
  ProductComparisonChartStyled,
} from './styles';

const config = {
  productComparisonChart: {
    columns: [
      {
        Header: 'Benefits',
        headerCellClassName: 'column-benefits',
        Footer: [''],
        accessor: 'feature',
      },
      {
        Header: 'Select™ Portfolio Immediate Income Annuities (PIIA)', // GOTCHA: Changing this to a fragment to encode the ™ will break the output for mobile.
        accessor: 'selectPortfolioImmediate',
      },
      {
        Header: 'Select™ Immediate Income Annuities (SPIA)',
        accessor: 'selectImmediate',
      },
      {
        Header: 'Select™ Portfolio Deferred Income Annuities (PDIA)',
        accessor: 'selectPortfolio',
      },
      {
        Header: 'Select™ Deferred Income Annuities (DIA)',
        accessor: 'selectDeferred',
      },
    ],
    data: [
      {
        feature: 'Lifetime income',
        selectPortfolioImmediate: 'true',
        selectImmediate: 'true',
        selectPortfolio: 'true',
        selectDeferred:'true',
      },
      {
        feature: 'Tax deferral',
        selectPortfolioImmediate: 'true',
        selectImmediate: 'true',
        selectPortfolio: 'true',
        selectDeferred:'true',
      },
      {
        feature: 'Death benefit',
        selectPortfolioImmediate: 'true',
        selectImmediate: 'true',
        selectPortfolio: 'true',
        selectDeferred:'true',
      },
      {
        feature: 'Potential to earn dividends and flexibility in using them',
        selectPortfolioImmediate: 'true',
        selectImmediate: '',
        selectPortfolio: 'true',
        selectDeferred:'',
      },
      {
        feature: 'Flexibility to change the amount and frequency of your payments including making regular payments, a single payment, fluctuating payments, and skipping payments',
        selectPortfolioImmediate: '',
        selectImmediate: '',
        selectPortfolio: 'true',
        selectDeferred:'',
      },
    ],
    hideSectionHeading: false,
    instructionalText: '',
    sectionHeading: <>Which type of annuity will help you meet your <WidowBlock>goals best&#63;</WidowBlock></>,
    selectCompare1: { labelText: 'Select a 1st product' },
    selectCompare2: { labelText: 'Select a 2nd product' },
  },
};

export default () => (
  <SectionContainer
    id='income-annuities-product-comparison-chart'
    backgroundVariant='lightC'
    themeType='lightTheme'
    className='nmx-nested nmx-product-comparison-table'
    moduleName='product-comparison-chart-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col align='center'>
        <ProductComparisonChartStyled
          id='income-annuities-product-comparison-chart'
          data-app-name='income-annuities-product-comparison-chart'
          data-static-config={config} />
        <LinkStyled
          variant='buttonLinkSecondary'
          id='income-annuities-product-comparison-chart-cta-fafa'
          linkUrl='https://www.northwesternmutual.com/life-and-money/what-are-the-different-types-of-annuities/'
          ariaLabel='Learn more about the different types of annuities'>
          Learn more
        </LinkStyled>
      </Col>
    </Row>
  </SectionContainer>
);
